import React, { useState } from 'react'
import classes from './ExecutorClusterItem.module.sass'
import chart from '../../../../../../../src/assets/images/icons/chart.svg'
import link from '../../../../../../assets/images/icons/link.svg'
import search from '../../../../../../assets/images/icons/search.svg'
import settings from '../../../../../../assets/images/icons/settings.svg' // ❌ добавь иконку
import { ExecutorClusterResponse } from '../../../../../../common/types/interfaces'
import { IconButton } from '../../../../../../common/components/iconButton/IconButton'

type Props = {
  cluster: ExecutorClusterResponse
  onStatsClick: (cluster: ExecutorClusterResponse) => void
  onDetailsClick: (cluster: ExecutorClusterResponse) => void
  onGoTo: (cluster: ExecutorClusterResponse) => void
  onSettingsClick: (cluster: ExecutorClusterResponse) => void
}

export const ExecutorClusterItem: React.FC<Props> = ({
  cluster,
  onStatsClick,
  onDetailsClick,
  onGoTo,
  onSettingsClick,
}) => {
  const [imgError, setImgError] = useState(false)

  const logoSrc = `https://${cluster.cluster.domain}/icons/logo512.png`

  return (
    <div className={classes.container}>
      <div className={classes.logoWrapper}>
        {!imgError ? (
          <img
            src={logoSrc}
            alt={cluster.cluster.name}
            className={classes.logo}
            onError={() => setImgError(true)}
          />
        ) : (
          <div className={classes.logoFallback}>{cluster.cluster.name.charAt(0).toUpperCase()}</div>
        )}
      </div>
      <div className={classes.name}>{cluster.cluster.name}</div>
      <div className={classes.buttons}>
        <IconButton
          display
          icon={search}
          alt="Детали"
          onClick={() => onDetailsClick(cluster)}
          small
        />
        <IconButton
          display
          icon={chart}
          alt="Статистика"
          onClick={() => onStatsClick(cluster)}
          small
        />
        <IconButton
          display
          icon={settings}
          alt="Настройки"
          onClick={() => onSettingsClick(cluster)}
          small
        />
        <IconButton display icon={link} alt="Перейти" onClick={() => onGoTo(cluster)} small />
      </div>
    </div>
  )
}
